import type { ComponentPropsWithRef, ReactNode } from 'react';

import { Card, Illustration, type IllustrationName, Title } from '~/components';
import { clsx } from '~/styles/utils';

import { cardStyle, contentStyle, descriptionStyle, illustrationStyle, illustrationWrapperStyle, titleStyle } from './NetworkInfoCard.css';

type Props = ComponentPropsWithRef<typeof Card.Root> & {
  action: ReactNode;
  description: ReactNode;
  illustration?: IllustrationName;
  illustrationStrokeWidth?: number;
  title: string;
};

export const NetworkInfoCard = ({
  action,
  description,
  illustration,
  illustrationStrokeWidth = 2,
  title,
  variant = 'secondary-brand',
  ...delegated
}: Props) => {
  return (
    <Card.Root {...delegated} className={clsx(cardStyle, delegated.className)} variant={variant}>
      <article className={contentStyle}>
        {illustration && (
          <div className={illustrationWrapperStyle}>
            <Illustration className={illustrationStyle} name={illustration} strokeWidth={illustrationStrokeWidth} />
          </div>
        )}

        <Title as="h2" className={titleStyle}>
          {title}
        </Title>

        <div className={descriptionStyle}>{description}</div>

        {action}
      </article>
    </Card.Root>
  );
};
